module.exports = __webpack_public_path__ + "static/img/jiexi.0e35abe0.png";